'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Tool(name, featured) {
  this.fh = null;
  this.fg = false;
  this.fh = name;
  this.fg = featured;
}
export { $c_Lio_intela_sites_intelacloud_content_Tool as $c_Lio_intela_sites_intelacloud_content_Tool };
$p = $c_Lio_intela_sites_intelacloud_content_Tool.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Tool;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Tool() {
}
export { $h_Lio_intela_sites_intelacloud_content_Tool as $h_Lio_intela_sites_intelacloud_content_Tool };
$h_Lio_intela_sites_intelacloud_content_Tool.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, 2612664);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().R(this.fh));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().l(acc, (this.fg ? 1231 : 1237));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().N(acc, 2);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Tool) && ((this.fg === x$0.fg) && (this.fh === x$0.fh))));
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Tool";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.fh;
  }
  if ((n === 1)) {
    return this.fg;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Tool(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bL)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Tool as $isArrayOf_Lio_intela_sites_intelacloud_content_Tool };
var $d_Lio_intela_sites_intelacloud_content_Tool = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Tool, "io.intela.sites.intelacloud.content.Tool", ({
  bL: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Tool as $d_Lio_intela_sites_intelacloud_content_Tool };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Tool.js.map
